module.exports = __webpack_public_path__ + "static/media/lipstick.c996ab9e.png";